import { render, staticRenderFns } from "./AvisoInformativo.vue?vue&type=template&id=2abd6565&scoped=true"
import script from "./AvisoInformativo.vue?vue&type=script&lang=js"
export * from "./AvisoInformativo.vue?vue&type=script&lang=js"
import style0 from "./AvisoInformativo.vue?vue&type=style&index=0&id=2abd6565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd6565",
  null
  
)

export default component.exports